<template>
  <v-app class="routebus-app">
    <RbFullPageLoader v-if="isLoading" />

    <template v-else-if="isLoginPage">
      <router-view />
    </template>

    <template v-else>
      <rb-sidebar v-model:drawer="drawer" :rail="rail" @toggle-sidebar="drawer = !drawer" />

      <rb-topbar :drawer="drawer" @toggle-sidebar="drawer = !drawer" />

      <v-main class="main-content">
        <v-container fluid class="content-container pa-0">
          <router-view />
        </v-container>
      </v-main>
    </template>

    <RbGlobalLoader />
    <RbNotification />
    <RbConfirmPopup />
  </v-app>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "App",

  components: {
    RbNotification: defineAsyncComponent(() =>
      import("@/shared/components/alerts/RbNotification.vue")
    ),

    RbConfirmPopup: defineAsyncComponent(() =>
      import("@/shared/components/alerts/RbConfirm.vue")
    ),

    RbGlobalLoader: defineAsyncComponent(() =>
      import("@/shared/components/loader/GlobalLoader.vue")
    ),

    RbFullPageLoader: defineAsyncComponent(() =>
      import("@/shared/components/loader/FullPageLoader.vue")
    ),
  },

  data() {
    return {
      drawer: true,
      rail: false,
    };
  },

  computed: {
    isLoginPage() {
      return this.$route.name === "Login";
    },

    isLoading() {
      return !this.$auth && !this.isLoginPage;
    },
  },
};
</script>

<style>
html,
body,
#app {
  min-height: 100%;
  margin: 0;
}

.routebus-app,
.v-application {
  background-color: rgb(var(--v-theme-background)) !important;
  color: rgb(var(--v-theme-on-background)) !important;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.main-content {
  min-height: 100vh;
  background-color: rgb(var(--v-theme-background)) !important;
}

.content-container {
  min-height: 100%;
  background-color: transparent !important;
}

@media (prefers-reduced-motion: reduce) {
  .routebus-app,
  .v-application {
    transition: none;
  }
}
</style>
